export default "__VITE_ASSET__60ebf0ed__"